import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN } = authRoles

const BusinessSector = () =>
  import(/* webpackChunkName: "users-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/business-sector',
    name: 'business-sector',
    component: BusinessSector,
    meta: {
      title: 'Business Sector',
      auth: {
        roles: [ADMIN], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/403', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
